class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this._fetchAbortController = null;
    this._boundOnHistoryChange = this.onHistoryChange.bind(this);
    this.accordionType = this.dataset.accordiontype;
    this.filterParent = this.closest('#filtersCollapse');
    this.quickshop = document.querySelector('quick-shop');
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.filterForm = this.querySelector('form');
    this.filterType = this.dataset.filtertype;

    const toggleBtns = this.querySelectorAll('.filter__toggle');
    toggleBtns.forEach(button => button.addEventListener('click', this.toggleFilterBlock.bind(this)));

    /*********** Open Drawer on Filter or SortBy button click. Close Drawer on close button click *************/
    this.openFilterDrawer = document.getElementById('filter-drawer');
    if(this.openFilterDrawer) this.openFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.openSortbyDrawer = document.getElementById('sortby-drawer');
    if(this.openSortbyDrawer) this.openSortbyDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    this.closeFilterDrawer = this.filterParent?.querySelector('.collection-filters-close');
    if(this.closeFilterDrawer) this.closeFilterDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    /*********** End of Open Drawer on Filter or SortBy button click. Close Drawer on close button click ********/

    /*********** End of Open Drawer on Filter or SortBy button click. Close Drawer on close button click ********/

    this.sortby_values = document.querySelectorAll('[data-sortby] .sortby_options');
    this.sortby_values.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    this.subCollectionLinks = document.querySelectorAll('[data-subCollections] .collection-entry');
    this.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    this.filterParent?.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE'){ this.closeFilterDrawer.dispatchEvent(new Event('click')); }
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
      this.filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      window.addEventListener('popstate', this._boundOnHistoryChange);
    }

    const applyBtn = this.querySelector('[data-applyFilters]');
    if(applyBtn){
      applyBtn.addEventListener('click', () => {
        this.filterForm.dispatchEvent(new Event('submit', {'bubbles' : true, 'cancelable' : true }));
        setTimeout(() => {
          this.closeFilterDrawer.dispatchEvent(new Event('click'));
        }, 1000);
      });
    }

    this._boundManagePagination = this._managePagination.bind(this);
    this.bindPaginationLinkEvents();

    this.bindActiveFilterButtonEvents();
    this.addAccessibilityAttributes(toggleBtns);
    this.colorOptionsStyling();
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this._boundOnHistoryChange);
    if (this._fetchAbortController) {
      this._fetchAbortController.abort();
      this._fetchAbortController = null;
    }
  }

  /**
   * Filter Block Toggle event
   * @param {NodeList} toggleBtns Open filter block buttons
   */
  addAccessibilityAttributes(toggleBtns) {
    toggleBtns.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    if(event.type == 'input' && this.filterParent?.classList.contains('filter-active')){
      return;
    }

    let closestForm = document.getElementById('CollectionFiltersForm');
    if(event.target && event.target.closest('form')){ closestForm = event.target.closest('form'); }
    if(!closestForm) return;

    const searchParams = this._finalQueryString(closestForm)

    this.renderPage(searchParams, event);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _finalQueryString(form){
    const formData = new FormData(form);
    let searchParams = '';
    let constraints = '';
    formData.forEach((val, key) => {
      if(key.indexOf('price-list') >= 0){
        searchParams += '&' + val;
      }else if(key.indexOf('custom_sort_by') >= 0){
        //  Code for SortBy
      }else if(key.indexOf('tagsFilter-') > -1){
        if(constraints === ''){ constraints = val; }
        else{ constraints += `+${val}`; }
      }else if(val != null && val.length > 0){
        if(searchParams === ''){ searchParams = key + '=' + val;}
        else{ searchParams += '&' + key + '=' + val; }
      }
    });

    if(constraints != ''){
      if(searchParams == ''){
        searchParams = `?constraint=${constraints}`;
      }else{
        searchParams += `&constraint=${constraints}`;
      }
    }

    return searchParams;
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = this.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    let currentTarget = event.target;
    let URLString = null

    if(!currentTarget.classList.contains('filter-option-clear')) {
      currentTarget = event.target.closest('.filter-option-clear')
      URLString = new URL(currentTarget.href).searchParams.toString();
    } else if (currentTarget.dataset.type == 'tag_based') {
      const inputValue = currentTarget.dataset.remove;
      const inputElement  = document.querySelector(`input[data-tagslist][value="${inputValue}"]`);
      if(inputElement) inputElement.checked = false;

      let closestForm = document.getElementById('CollectionFiltersForm');
      if(!closestForm) return;
      URLString = this._finalQueryString(closestForm);
    } else {
      URLString = new URL(currentTarget.href).searchParams.toString();
    }

    if(URLString != null) this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  renderPage(searchParams, event, updateURLHash = true) {
    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderGridFromFetch(url, type) {
    if(!url) return;
    this._setGridLoadingState(true);

    if (this._fetchAbortController) {
      this._fetchAbortController.abort();
    }
    this._fetchAbortController = new AbortController();
    const signal = this._fetchAbortController.signal;

    const sectionId = this._getCollectionSectionRequestId();
    window.FilterShared.fetchSectionAwareHtml(url, sectionId, signal, 'Collection')
      .then((html) => {
        if (typeof html === 'string' && html.length > 0) {
          this.renderProductGrid(html, type);
          return;
        }
        this._setGridLoadingState(false);
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        console.error('Collection filter fetch failed:', err);
        this._setGridLoadingState(false);
      });
  }

  _setGridLoadingState(isLoading) {
    window.FilterShared.setGridLoadingState('collection-product-grid', isLoading);
  }

  _getCollectionSectionRequestId() {
    const grid = document.getElementById('product-grid');
    if (grid?.dataset?.id) {
      return grid.dataset.id;
    }
    const sectionWrapper = grid?.closest('[id^="shopify-section-"]');
    if (sectionWrapper?.id?.startsWith('shopify-section-')) {
      return sectionWrapper.id.slice('shopify-section-'.length);
    }
    return 'main';
  }

  renderProductGrid(html, type) {
    const innerHTML = new DOMParser().parseFromString(html, 'text/html');
    let paginationType = 'numbers';
    if(document.querySelector('[data-pagination][data-type]')){
      paginationType = document.querySelector('[data-pagination][data-type]').dataset.type || 'numbers';
    }
    if(type == 'filter' || type == 'sub_collection_filter'){
      const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
      document.getElementById('collection-product-grid').innerHTML = gridHTML;

      if(type == 'sub_collection_filter'){
        let bannerHTML = innerHTML.querySelector('[data-collectionBanner]').innerHTML;
        document.querySelector('[data-collectionBanner]').innerHTML = bannerHTML;
      }
    }else{
      if(paginationType == 'loadmore'){
        let productGrids = innerHTML.getElementById('template-collection').innerHTML;
        let loadMoreBtn =  innerHTML.getElementById('load-more');
        document.getElementById('template-collection').insertAdjacentHTML('beforeend', productGrids);
        if(loadMoreBtn && document.getElementById('load-more')){ 
          document.getElementById('load-more').parentNode.replaceChild(loadMoreBtn, document.getElementById('load-more')); 
        }
        else if(document.getElementById('load-more')){ document.getElementById('load-more').remove(); }
      }else{
        const sourceGrid = innerHTML.getElementById('collection-product-grid');
        const currentGrid = document.getElementById('collection-product-grid');
        if (sourceGrid && currentGrid) {
          currentGrid.innerHTML = sourceGrid.innerHTML;
        }
      }
    }

    const sourcePagination = innerHTML.querySelector('[data-pagination][data-type]');
    const currentPagination = document.querySelector('[data-pagination][data-type]');
    if (sourcePagination && currentPagination) {
      currentPagination.replaceWith(sourcePagination);
    } else if (sourcePagination && !currentPagination) {
      const collectionGrid = document.getElementById('collection-product-grid');
      if (collectionGrid) {
        collectionGrid.insertAdjacentElement('afterend', sourcePagination);
      }
    } else if (!sourcePagination && currentPagination) {
      currentPagination.remove();
    }

    const openFilters = document.querySelectorAll('.filter__container.open');
    const filterInnerHTML = innerHTML.getElementById('main-collection-filters').innerHTML;
    document.getElementById('main-collection-filters').innerHTML = filterInnerHTML;

    if(this.filterType === 'sidebar-filters'){
      // reopen filter blocks which are active before HTML update
      openFilters.forEach(openFilter => {
        if(openFilter.querySelector('.filter__toggle')){
          openFilter.querySelector('.filter__toggle').setAttribute('aria-expanded', true);
        }
        let filterBlock = document.querySelector('.filter__container[data-index="'+openFilter.dataset.index+'"]');
        filterBlock.classList.add('open');
        filterBlock.querySelector('.filter__block').classList.add('open');
      });
    }

    const filterContainers = document.querySelectorAll('.filter__container');

    filterContainers.forEach(filter => {
      const tagList = filter.querySelectorAll('.filter__item');
      if(tagList.length === 0 && !filter.querySelector('price-range')){
        filter.classList.add('d-none');
        filter.style.display = 'none';
      }
    });
    
    const totalProducts = innerHTML.querySelector('[data-totalProducts]');
    if(totalProducts) document.querySelector('[data-totalProducts]').innerHTML = totalProducts.innerHTML;

    const activeFilters = innerHTML.querySelector('[data-activeFilters]');
    if(activeFilters) document.querySelector('[data-activeFilters]').innerHTML = activeFilters.innerHTML;

    const horizontalFilters = innerHTML.querySelector('[data-filter-horizontal]');
    if(horizontalFilters) document.querySelector('[data-filter-horizontal]').innerHTML = horizontalFilters.innerHTML;

    this.bindPaginationLinkEvents();
    this.bindActiveFilterButtonEvents();
    this.refreshCardActionButtons();
    this._setGridLoadingState(false);
  }

  refreshCardActionButtons() {
    window.FilterShared.refreshCardActionButtons(this.quickshop, '#collection-product-grid');
  }

  bindActiveFilterButtonEvents() {
    document.querySelectorAll('.filter-option-clear').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  bindPaginationLinkEvents() {
    window.FilterShared.bindPaginationLinkEvents(this._boundManagePagination);
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  updateSortBy(event){
    let _this = event.currentTarget;

    let currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_mobile"]:checked')?.value;

    if(_this.name == 'custom_sort_by_desktop'){
      currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_desktop"]:checked')?.value;
    }

    if(currentvalue) {
      this.querySelector('[name="sort_by"]').value = currentvalue;
      this.querySelector('[name="sort_by"]').dispatchEvent(new Event('input', {
        bubbles: true,
        cancelable: true,
      }));
    }
  }

  _manageSubCollections(event){
    event.preventDefault();
    const _this =  event.currentTarget;
    let closestForm = document.getElementById('CollectionFiltersForm');
    if(_this.closest('form')){ closestForm = event.target.closest('form'); }
    const queryString = this._finalQueryString(closestForm);

    let collURL = _this.href + '?' + queryString;
    this.renderGridFromFetch(collURL, 'sub_collection_filter');
    setTimeout(() => {
      history.pushState({}, '', collURL);
    }, 500);
  }

  _managePagination(event){
    event.preventDefault();
    let _this = event.currentTarget;
    const nextPageLink = _this.href;
    this.scrollToResultsTop();
    this.renderGridFromFetch(nextPageLink, 'pagination');

    setTimeout(() => {
      history.pushState({}, '', nextPageLink);
    }, 500);
  }

  scrollToResultsTop() {
    window.FilterShared.scrollToResultsTop('#collection_title', '#collection-product-grid', 'auto');
  }

  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer' || button.id == 'sortby-drawer'){
      this.filterParent?.classList.add('filter-active');
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      if(button.id == 'sortby-drawer'){ this.filterParent?.classList.add('sortby-drawer'); }
      else{ this.filterParent?.classList.remove('sortby-drawer'); }

      if(this.filterParent) {
        Utility.trapFocus(this.filterParent);
        Utility.forceFocus(this.closeFilterDrawer);
      }
      siteOverlay.prototype.showOverlay();
    }else{
      this.filterParent?.classList.remove('filter-active');
      this.filterParent?.classList.remove('sortby-drawer');
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(this.filterParent);
      siteOverlay.prototype.hideOverlay();
    }
  }

  toggleFilterBlock(event) {
    event.preventDefault();
    const toggleFilterBtn = event.currentTarget;
    const filterContainer = toggleFilterBtn.parentNode;
    const isOpen = filterContainer.classList.contains('open');
    isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
  }

  openFilterBlock(toggleFilterBtn){
    let filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(filterContainer, 'open');
    if(this.accordionType == 'single'){
      let siblingBlocks = filterContainer.parentNode.querySelectorAll('.filter__container');
      siblingBlocks.forEach(element => {
        if(element == filterContainer){ return; }
        element.classList.remove('open');
        element.querySelector('.filter__block').classList.remove('open');
        element.querySelector('.filter__toggle').setAttribute('aria-expanded', false);
      });
    }
    Utility.trapFocus(filterContainer);
  }

  closeFilterBlock(toggleFilterBtn){
    const filterContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(filterContainer, 'close');
    Utility.removeTrapFocus(filterContainer);
  }
}

customElements.define('collection-filters', CollectionFilters);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);
